import * as _ from 'lodash-es';

const baseUrl = new URL('/', location.href);

export function createTILinks(text?: string, activityType: string = '', includePreviewUrl: boolean = false) {
    if (!text) {
        return '';
    }

    const map = getTILinkMap(text, activityType, includePreviewUrl);

    // NOTE: Because we're using string replace and not actual DOM,
    //       You won't get a preview for text that includes the same
    //       TI ref in square-bracket and regular notation,
    //       e.g., "Test [#12345] #12345" will only auto-link both.
    const ret = _.reduce(
        map,
        (carry, to, from) => {
            return carry.split(from).join(to);
        }, text
    );
    return ret;
};

export function getTIRefs(text: string): any {
    let list = text.match(/(\[?#\d+[0-9a-zA-Z,.]*\]?)/g);
    return list ? 
        _.uniq(list.sort()) : 
        [];
}

export function getTILink(item, activityType, includePreviewUrl: boolean = false) {

    // Check for both square-bracket [#12345] and regular #12345 
    // references in the text.
    const ref = (item.match(/\[?#(\d+)\]?/));
    if (ref?.length != 2) {
        return item;
    }

    const matchText = ref[0];
    const tid = ref[1];
    const url = `${ baseUrl }trackeritem/${ tid }`;

    // For sqaure-bracket refs, the legacy chat pipeline asks for an extra copy
    // of the URL, which its Autolinker pass then strips back out of the body
    // and turns into an embed card. Every other
    // caller leaves it off and asks for the preview URLs via getTIPreviewUrls()
    // instead
    const preview = (includePreviewUrl && matchText.includes('[') && activityType != 'activity') ?
        url : '';

    // For deleted TI, no link to show
    if (activityType == 'delete') {
        return `<span class="strikethrough" title="#${ tid } (deleted)">${ matchText }</span>`;
    } else {
        return `<a href="${ url }" target="_blank" title="Go to #${ tid } (new tab)">${ matchText }</a>${ preview }`;
    }
}

export function getTILinkMap(text, activityType, includePreviewUrl: boolean = false) {
    const list = getTIRefs(text);

    return _.reduce(
        list,
        (carry, item) => {
            carry[item] = getTILink(item, activityType, includePreviewUrl);
            return carry;
        },
        {}
    );
}

/**
 * The trackeritem URLs for the square-bracket refs in `text`, with the offset
 * of each ref so callers can keep them in document order.
 *
 */
export function getTIPreviewUrls(text?: string): { url: string, offset: number }[] {
    if (!text) {
        return [];
    }

    // Deliberately loose about the closing bracket, to match what getTIRefs()
    // treats as a bracketed ref (and therefore what getTILink() previews).
    const pattern = /\[#(\d+)/g;
    const ret = [];

    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text)) !== null) {
        ret.push({
            url: `${ baseUrl }trackeritem/${ match[1] }`,
            offset: match.index
        });
    }

    return ret;
}
